import axios from './configAxiosClean'

export const deleteTerminalAccessForUserApi = async (terminal_id, user_id) => {
    return axios.delete(`/staff/${user_id}/terminal/access/delete/${terminal_id}/`);
  };